import { Injectable } from '@angular/core';
import { LimitReport } from '@clean-code/models';
import { DataTableParameters, ID, PagingResponse } from '@clean-code/models/common';
import { EditSearchDataService } from '@clean-code/shared/util/util-data-service';
import { Observable } from 'rxjs';
import { LimitReportOtherService } from './limit-report.service';

@Injectable({ providedIn: 'root' })
export class LimitReportOtherListFacade
  implements EditSearchDataService<LimitReport> {
  constructor(protected service: LimitReportOtherService) {
  }

  public getAll$(
    params: DataTableParameters
  ): Observable<PagingResponse<LimitReport>> {
    return this.service.getAll$(params);
  }

  public getById$(id: ID): Observable<LimitReport> {
    return this.service.getById$(id);
  }

  add$(entity: LimitReport): Partial<Observable<boolean | LimitReport | ID>> {
    throw new Error('Method not implemented.');
  }

  update$(
    entity: LimitReport
  ): Partial<Observable<boolean | LimitReport | ID>> {
    throw new Error('Method not implemented.');
  }

  delete$(id: ID): Partial<Observable<boolean | void>> {
    return this.service.delete$(id);
  }

  // public get searchTerm(): string {
  //   return this.query.searchTerm;
  // }
}
